import styled from "styled-components";
import { typographyMixin } from "../../typography";

export const StyledPagination = styled.div`
  ${typographyMixin}

  .button {
    &.currentPage {
      text-decoration: underline;
    }
  }
`;
